var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M301.783 374.282C284.662 403.937 246.743 414.097 217.089 396.976L175.838 373.16C146.184 356.039 136.024 318.12 153.145 288.466L233.776 148.809L382.414 234.626L301.783 374.282Z",
    fill: "#F9F9F9",
    stroke: "#1C1B1F",
    strokeWidth: 15
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 235.371,
    y: 101.393,
    width: 216.285,
    height: 41.8616,
    rx: 16,
    transform: "rotate(30 235.371 101.393)",
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M335.093 153.328L355.326 118.283",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.972 432.733L199.484 386.812",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M392.021 137.052L319.515 95.1908",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M255.6 222.638L212.097 197.521",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M259.91 265.407L194.654 227.732",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M258.178 304.688L177.212 257.943",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNone);
export default __webpack_public_path__ + "static/media/일반외과_none.033a4d590c940a1d19e666996e7f9219.svg";
export { ForwardRef as ReactComponent };